import Login from '../../views/login/login.vue'

export default {
    path: "/login",
    name: "Login",
    component: Login
}